import { View, VStack, HStack, Divider } from "@gluestack-ui/themed";
import { EmergencyWithdrawController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { InstallmentsInput } from "@repo/core/components/core/InstallmentsInput";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import Spinner from "@repo/core/components/core/Spinner";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const EmergencyWithdraw = () => {
  const {
    back,
    isMobile,
    installments,
    handleIncrementInstallments,
    handleDecrementInstallments,
    control,
    isLoadingInstallments,
    isValid,
    isSubmitting,
    handleOnSubmitForm,
    totalValue
  } = EmergencyWithdrawController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title="Saque Emergencial">
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                isDisabled={!isValid}
                isLoading={isSubmitting}
                action={isValid ? "primary" : "secondary"}
                text="Concluir transação"
                onPress={handleOnSubmitForm}
              />
              <Button
                flex={isMobile ? undefined : 1}
                isDisabled={isSubmitting}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={back}
              />
            </View>
          }
        >
          <VStack gap={24} px="$4">
            <Text>Insira os dados do saque:</Text>

            {/* <IdentityTypeInput control={control} /> */}

            <InputControlled
              control={control}
              name="withdrawValue"
              size="md"
              returnKeyType="next"
              label="Valor do Saque"
              isRequired
              isCurrency
              isBigInput
            />
            <InstallmentsInput
              installments={installments}
              totalValue={1250}
              maxInstallments={12}
              interest={0.6}
              onIncrement={handleIncrementInstallments}
              onDecrement={handleDecrementInstallments}
              isLoadingInstallments={isLoadingInstallments}
            />
          </VStack>
          {isMobile && <Divider h="$2" />}
          <VStack px={isMobile ? "$0" : "$4"} flex={1}>
            <HStack
              py={isMobile ? "$0" : "$3"}
              bg={isMobile ? "$backgroundLight0" : "$backgroundLight100"}
              borderRadius={isMobile ? "$none" : "$lg"}
              justifyContent="space-between"
              alignItems="center"
              px="$4"
            >
              <Text fontWeight={500}>Valor Total:</Text>
              {isLoadingInstallments ? (
                <Spinner color="$secondary400" size={20} />
              ) : (
                <Text fontWeight={600}>{numberToBrl(totalValue)}</Text>
              )}
            </HStack>
          </VStack>
          {isMobile && <Divider />}
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default EmergencyWithdraw;
